import { PIcon, PIconProps } from '@porsche-design-system/components-react';
type StarIconProps = Omit<PIconProps, 'name' | 'key'>;

export type StarsOutputProps = {
  rating: number;
  hover?: number;
  onStarClick?: (starValue: number) => void;
  onStarMouseEnter?: (starValue: number) => void;
  onStarMouseLeave?: () => void;
} & StarIconProps;

export const StarsOutput = ({
  rating,
  hover = 0,
  onStarClick,
  onStarMouseEnter,
  onStarMouseLeave,
  ...rest
}: StarsOutputProps) => (
  <>
    {[...Array(5)].map((_, index) => {
      const starValue = index + 1;
      return (
        <PIcon
          {...rest}
          key={starValue}
          name={starValue <= (hover || rating) ? 'star-filled' : 'star'}
          onClick={() => onStarClick?.(starValue)}
          onMouseEnter={() => onStarMouseEnter?.(starValue)}
          onMouseLeave={() => onStarMouseLeave?.()}
        />
      );
    })}
  </>
);
